import { useCallback } from 'react';
import OpeningClass from '../../../helpers/OpeningClass';
import { useDispatch, useSelector } from 'react-redux';
import { measurementsActions } from '../../../../../store/slices/measurementsSlice/measurementsSlice';

export const useOpenings = () => {
    const dispatch = useDispatch();
    const { ids: openingsList } = useSelector((state) => state.measurementsReducer.openingsList);

    const addCard = useCallback(() => {
        const newCard = new OpeningClass();
        dispatch(measurementsActions.addOpening(newCard.toPlainObject()));
    }, []);

    return { openingsList, addCard };
};
